"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Loader = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireDefault(require("react"));

var _Funnel = _interopRequireDefault(require("@jobmatchme/profile-components/es/components/Funnel"));

var _LoadingComponent = _interopRequireDefault(require("@jobmatchme/pc-funnel/es/components/LoadingComponent"));

var _Pc = require("@jobmatchme/amplify-tools/es/api/Pc");

var _LogoJMM = _interopRequireDefault(require("@jobmatchme/ui/es/components/LogoJMM"));

var _Header = _interopRequireDefault(require("@jobmatchme/ui/es/components/Header"));

var _jsxRuntime = require("react/jsx-runtime");

var constructRegistration = function constructRegistration(_ref) {
  var _ref$configKey = _ref.configKey,
      configKey = _ref$configKey === void 0 ? 'registration' : _ref$configKey,
      progressStepperVariant = _ref.progressStepperVariant,
      MatchesScreen = _ref.MatchesScreen,
      actionButton = _ref.actionButton,
      config = _ref.config;
  return function (_ref2) {
    var matchesNumber = _ref2.matchesNumber;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Funnel.default, {
      progressStepperVariant: progressStepperVariant,
      configKey: configKey,
      actionButton: actionButton,
      startScreen: MatchesScreen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(MatchesScreen, {
        matchesNumber: matchesNumber,
        discriminator: config.discriminator
      }) : undefined
    });
  };
};

var _default = constructRegistration;
exports.default = _default;

var loadMatches = function loadMatches() {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(profile) {
      var _matches;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _Pc.PcApi.post('/matchingService/matchProfile/noUser', profile);

            case 3:
              _matches = _context.sent;
              return _context.abrupt("return", _matches);

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error('loadMatchesError', _context.t0);

            case 10:
              return _context.abrupt("return", []);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var Loader = function Loader(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        height: '60px',
        marginTop: '8px'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default, {
        logo: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LogoJMM.default, {
          exact: true,
          height: "50",
          width: "50",
          variant: "circleFull",
          pointer: true
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingComponent.default, (0, _extends2.default)({
      loadMatches: loadMatches()
    }, props))]
  });
};

exports.Loader = Loader;